var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLayoutIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 10,
  viewBox: "0 0 15 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 9,
  height: 9,
  rx: 0.5,
  stroke: "currentColor"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 11.5,
  y: 0.5,
  width: 3,
  height: 9,
  rx: 0.5,
  stroke: "currentColor"
})));
export default SvgLayoutIcon;